import { BaseQuestionnaireRoute } from '../slice';

export type SaleofOtherAssetsRoutes = BaseQuestionnaireRoute;

export const saleofOtherAssetsRoutes: { saleofOtherAssets: SaleofOtherAssetsRoutes } = {
    saleofOtherAssets: {
    title: 'Sale of Other Assets',
    path: 'saleofOtherAssets',
    isValid: undefined,
  },
};
